// @flow
import i18n from 'i18next';
import React from 'react';
import styled from 'styled-components';
import TextField from 'material-ui/TextField';
import { formatCurrency, parseCurrency } from '../helpers/currency/currency';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

type Props = {
  onBlur: (numeric: number) => void;
  value?: number;
  style?: Object;
  inputStyle?: Object;
  underlineStyle?: Object;
};

type State = {
  value: string;
};

class MonetaryTextField extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { value: this.format(props.value || 0) };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({ value: this.format(nextProps.value || 0) });
  }

  format = (value: number): string => {
    const formatted = formatCurrency(i18n.language, value);
    return formatted.indexOf('NaN') === -1 ? formatted : this.format(0);
  };

  onChange = (event: Object, value: string): void => {
    this.setState({ value: value });
  };

  onBlur = (event: Object): void => {
    const currencyValue = event.target.value;
    this.props.onBlur(parseCurrency(i18n.language, currencyValue));
  };

  render() {
    const { style, inputStyle, underlineStyle } = this.props;

    return (
      <Wrapper>
        <TextField
          id="money-field"
          {...this.props}
          value={this.state.value}
          onChange={this.onChange}
          onBlur={this.onBlur}
          min={0}
          fullWidth
          style={style}
          inputStyle={inputStyle}
          underlineStyle={underlineStyle}
        />
      </Wrapper>
    );
  }
}


export default MonetaryTextField;



// WEBPACK FOOTER //
// ./src/statsradio/components/MonetaryTextField.js